import React from 'react';
import { Info } from 'lucide-react';

interface FrictionLegendProps {
  isVisible: boolean;
}

const FRICTION_LEVELS = [
  { level: 'low', label: 'Low Friction', range: '0-25', color: '#48bb78' },
  { level: 'moderate', label: 'Moderate', range: '26-50', color: '#ecc94b' },
  { level: 'high', label: 'High Friction', range: '51-75', color: '#ed8936' },
  { level: 'critical', label: 'Critical', range: '76-100', color: '#f56565' }
];

const FrictionLegend: React.FC<FrictionLegendProps> = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="absolute top-4 right-4 bg-white rounded-lg shadow-lg border border-gray-200 p-4 z-50">
      <div className="flex items-center gap-2 mb-3">
        <Info className="w-4 h-4 text-gray-500" />
        <span className="text-sm font-semibold text-gray-700">Friction Heatmap</span>
      </div>
      <div className="space-y-2">
        {FRICTION_LEVELS.map((item) => (
          <div key={item.level} className="flex items-center gap-3">
            <div
              className="w-6 h-6 rounded"
              style={{ backgroundColor: item.color }}
            />
            <div className="flex flex-col">
              <span className="text-xs font-medium text-gray-700">{item.label}</span>
              <span className="text-xs text-gray-500">Score: {item.range}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-3 pt-3 border-t border-gray-200">
        <p className="text-xs text-gray-500">
          Higher scores indicate more friction
          (errors, delays, manual effort)
        </p>
      </div>
    </div>
  );
};

export default FrictionLegend;
